import {styled} from '@mui/material/styles'
import {Box, Button, Divider, Grid, MenuItem, Typography} from '@mui/material'

export const StyledCircularContainer = styled(Box)(() => ({
  height: '59vh',
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex'
}))

export const StyledInterestTagDivContainer = styled('div')(() => ({
  marginBottom: '20px'
}))

export const StyledCategoryField = styled(Typography)(({theme}) => ({
  color: theme.palette.common.black,
  fontSize: theme.typography.heading.fontSize.l,
  fontWeight: theme.typography.heading.fontWeight.semibold,
  marginBottom: '10px'
}))

export const StyledDivider = styled(Divider)(({theme}) => ({
  width: '60%',
  backgroundColor: theme.palette.common.black,
  height: '2px',
  marginBottom: '24px'
}))

export const StyledGridContainer = styled(Grid)(() => ({
  marginBottom: '10px'
}))

export const StyledGridItem = styled(Grid)(() => ({
  '&.MuiGrid-item': {
    padding: '0px 0px 0px 8px'
  }
}))

export const StyledMenuItem = styled(MenuItem)(() => ({
  padding: '0px'
}))

export const StyledButtonContainer = styled(Box)(() => ({
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex'
}))

export const StyledMoreButton = styled(Button)(({theme}) => ({
  color: theme.palette.common.blue1,
  textTransform: 'none',
  fontSize: theme.typography.heading.fontSize.xs
}))

export const StyledLoadingButton = styled(Button)(({theme}) => ({
  color: theme.palette.common.red,
  textTransform: 'none',
  fontSize: theme.typography.heading.fontSize.xs
}))

export const StyledTryAgainButton = styled(Button)(({theme}) => ({
  border: 'none',
  textTransform: 'lowercase',
  fontSize: theme.typography.heading.fontSize.xs,
  padding: '0px',
  marginLeft: '7px',
  marginBottom: '2px',
  textDecoration: 'underline',
  color: theme.palette.common.red
}))

export const StyledTypography = styled(Typography)(({theme}) => ({
  color: theme.palette.common.red,
  fontSize: theme.typography.heading.fontSize.xs,
  display: 'flex',
  alignItems: 'center'
}))

export const StyledSearchTypography = styled(Typography)(({theme}) => ({
  color: theme.palette.common.black,
  marginBottom: '4px'
}))

export const StyledSearchContainer = styled('div')(() => ({
  display: 'flex',
  marginBottom: '16px'
}))
